export default __webpack_public_path__ + "static/media/color-tag.ff5a97ea.svg";